import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { makeGetCurrentTeam } from 'selectors/teams';

import config from '../config';

import { routeHasProp } from 'services/navigation-service';

import ModalRoot from 'lazy/LazyModalRoot';

import AppBar from 'components/AppBar';
import AnchorUrlPreview from 'components/anchor-url-preview';

import { OSProvider } from 'context/OSContext';
import { IdleProvider } from 'context/IdleContext';
import { MeetingEmbedContext } from 'context/MeetingEmbedContext';
import { OverlayTaskProvider } from 'context/OverlayTaskContext';
import { HarvestProvider } from 'context/HarvestContext';

import Sockets from '../sockets';

class AppRoot extends PureComponent {
    render() {
        return (
            <MeetingEmbedContext.Consumer>
                {
                    meetingEmbedCtx => (
                        <Sockets host={this.props.team && (this.props.team?.feature_flags?.includes('UseAltAPI') ? config.ALT_SOCKET_HOST : config.SOCKET_HOST)}>
                            <OSProvider>
                                <IdleProvider>
                                    <HarvestProvider>
                                        <OverlayTaskProvider>
                                            {
                                                !routeHasProp('appBarHidden', this.props.location.pathname) ? <AppBar /> : null
                                            }
                                            <div className={'app-inner' + (meetingEmbedCtx.inApp ? ' in-meeting-embed' : '')}>
                                                { this.props.children }

                                                {
                                                    this.props.modal.modalType ? (
                                                        <ModalRoot modalType={this.props.modal.modalType} modalProps={this.props.modal.modalProps} />
                                                    ) : null
                                                }

                                            </div>

                                            <AnchorUrlPreview />
                                        </OverlayTaskProvider>
                                    </HarvestProvider>
                                </IdleProvider>
                            </OSProvider>
                        </Sockets>
                    )
                }
            </MeetingEmbedContext.Consumer>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();

    return ({ modal, teams }) => ({
        modal,
        team: getCurrentTeam(teams),
    });
};

export default withRouter(connect(makeMapStateToProps)(AppRoot));
